// ══════════════ RH TERRAIN (absences + commentaire check-in/out) ══════════════
// Extrait de GerantClientUI.jsx (refacto étape D — briques terrain, 07/07/2026).
// LeaveForm et CommentaireModal sont utilisés ensemble par GerantUI et StaffUI.
// Feuilles indépendantes : aucune référence croisée entre les deux, ni vers un
// composant interne encore non extrait de GerantClientUI.
import React, { useState } from 'react';
import { today, now, fname, tp, fd } from "../utils.js";
import { TT } from "../constants.js";

function LeaveForm({sid,staff,gerants,onSave,onC,prefill,adminMode,warnResubmit}){
  // adminMode=true : admin crée/modifie une absence directement (statut "approved" d'office, choix du salarié possible)
  // prefill : absence existante à éditer (sinon création)
  const isEdit=!!prefill?.id;
  // En mode admin, on liste salariés + direction (gérants), mais on exclut les archivés (pour la création).
  // Sur une absence existante d'un salarié archivé (édition), on inclut quand même son nom pour que l'affichage marche.
  const baseStaff=(staff||[]).filter(s=>!s.archived);
  const baseGerants=((gerants||[]).map(g=>({...g,_gerant:true}))).filter(g=>!g.archived);
  let allWorkers=adminMode?[...baseStaff,...baseGerants]:(staff||[]);
  // Si on édite une absence existante dont le salarié est archivé, on le ré-injecte dans la liste pour pouvoir l'afficher
  if(isEdit&&adminMode&&prefill?.sid&&!allWorkers.some(w=>w.id===prefill.sid)){
    const archived=[...(staff||[]),...((gerants||[]).map(g=>({...g,_gerant:true})))].find(w=>w.id===prefill.sid);
    if(archived)allWorkers=[...allWorkers,archived];
  }
  const[selSid,setSelSid]=useState(prefill?.sid||sid||allWorkers[0]?.id||'');
  const me=allWorkers.find(s=>s.id===selSid);
  const hasRecup=me?.recupEnabled;
  const hasRepos=me?.reposEnabled;
  const[type,setType]=useState(prefill?.type||'conge'); // conge | demi | recup | indispo | repos
  const[f,setF]=useState({
    sd:prefill?.sd||today(),
    ed:prefill?.ed||tp(1),
    demi:prefill?.demi||'am',
    reason:prefill?.reason||'',
    indispoType:prefill?.indispoType||'creneau',
    indispoStart:prefill?.indispoStart||'09:00',
    indispoEnd:prefill?.indispoEnd||'17:00',
    malType:prefill?.malType||'maladie',
  });
  const set=(k,v)=>setF(x=>({...x,[k]:v}));
  const save=()=>{
    if(!selSid){window.alert('Choisis un salarié.');return;}
    // En édition : on conserve l'id et la date de création, et on respecte le statut existant
    const baseId=prefill?.id||('l'+Date.now());
    const baseCa=prefill?.ca||now();
    // Statut :
    // - création par salarié : "pending"
    // - création par admin (adminMode) : "approved" directement
    // - édition : conserve le statut existant (admin peut éditer une pending sans l'approuver)
    const baseSt=isEdit?prefill.st:(adminMode?'approved':'pending');
    const base={id:baseId,sid:selSid,st:baseSt,ca:baseCa,type,reason:f.reason};
    if(type==='conge') onSave({...base,sd:f.sd,ed:f.ed});
    else if(type==='repos') onSave({...base,sd:f.sd,ed:f.sd});
    else if(type==='demi') onSave({...base,sd:f.sd,ed:f.sd,demi:f.demi});
    else if(type==='recup') onSave({...base,sd:f.sd,ed:f.sd,demi:f.demi});
    else if(type==='indispo') onSave({...base,sd:f.sd,ed:f.sd,indispoType:f.indispoType,indispoStart:f.indispoStart,indispoEnd:f.indispoEnd});
    else if(type==='maladie') onSave({...base,sd:f.sd,ed:f.ed,malType:f.malType||'maladie'});
  };
  return(<div style={{display:'flex',flexDirection:'column',gap:14}}>
    {/* Bandeau : modification d'une demande déjà approuvée par le salarié */}
    {warnResubmit&&<div style={{background:'#fff4d6',border:'1px solid var(--ye)',borderRadius:9,padding:'9px 12px',fontSize:11,color:'#7a5a00',lineHeight:1.5}}>
      ⚠️ Cette absence est <strong>déjà approuvée</strong>. En la modifiant, elle <strong>repasse en attente de validation</strong> : l'approbation précédente est annulée jusqu'à ce que la Direction valide la nouvelle demande.
    </div>}
    {/* Sélecteur de salarié — uniquement en mode admin (création depuis l'admin) */}
    {adminMode&&<div>
      <label className="fl">Salarié concerné</label>
      <select value={selSid} onChange={e=>setSelSid(e.target.value)} disabled={isEdit}>
        {allWorkers.map(w=>(<option key={w.id} value={w.id}>{fname(w)}{w._gerant?' (direction)':''}</option>))}
      </select>
      {isEdit&&<div style={{fontSize:10,color:'var(--si)',marginTop:4}}>Le salarié ne peut pas être changé sur une absence existante. Annule-la et recrée-en une au bon nom.</div>}
    </div>}
    {/* Bandeau info mode admin */}
    {adminMode&&<div style={{background:'#fff4d6',border:'1px solid var(--ye)',borderRadius:9,padding:'9px 12px',fontSize:11,color:'#7a5a00'}}>
      ⚙️ Mode admin — {isEdit?'la modification est enregistrée immédiatement':'l\'absence sera créée directement avec le statut "Approuvée"'}, sans demande à valider.
    </div>}
    {/* Type */}
    <div>
      <label className="fl">Type {adminMode?'d\'absence':'de demande'}</label>
      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:7}}>
        {[
          ['conge', '🌴', 'Congés', 'Journée(s) complète(s)'],
          ...(hasRepos||adminMode?[['repos','🔄','Repos hebdo','Jour de repos flottant']]:[] ),
          ['demi',  '🌗', 'Demi-journée', 'Matin ou après-midi'],
          ...(hasRecup||adminMode?[['recup','⏱','Récupération','Heures à rattraper']]:[] ),
          ['indispo','⏰','Indispo partielle','Sans engendrer de congés'],
          ...(adminMode?[['maladie','🏥','Arrêt maladie','Maladie / accident du travail']]:[] ),
        ].map(([v,e,l,sub])=>(
          <button key={v} onClick={()=>setType(v)} style={{padding:'10px 12px',borderRadius:12,border:`2px solid ${type===v?'var(--mn)':'var(--li)'}`,background:type===v?'#e1f7ee':'var(--wh)',cursor:'pointer',textAlign:'left'}}>
            <div style={{fontSize:18,marginBottom:3}}>{e}</div>
            <div style={{fontSize:12,fontWeight:700,color:type===v?'#1e6e3d':'var(--ink)'}}>{l}</div>
            <div style={{fontSize:10,color:'var(--si)'}}>{sub}</div>
          </button>
        ))}
      </div>
    </div>

    {/* Congés journées entières */}
    {type==='conge'&&<div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10}}>
      <div><label className="fl">Du</label><input type="date" value={f.sd} onChange={e=>set('sd',e.target.value)}/></div>
      <div><label className="fl">Au (inclus)</label><input type="date" value={f.ed} onChange={e=>set('ed',e.target.value)}/></div>
    </div>}

    {/* Repos hebdomadaire flottant */}
    {type==='repos'&&<div style={{display:'flex',flexDirection:'column',gap:10}}>
      <div style={{background:'#fff4d6',border:'1px solid var(--ye)',borderRadius:9,padding:'9px 12px',fontSize:11,color:'#7a5a00',lineHeight:1.5}}>
        ⚠️ Vous demandez à positionner votre <strong>jour de repos hebdomadaire</strong> à cette date. Cette demande <strong>n'est pas automatiquement accordée</strong> : elle reste soumise à validation et aux contraintes de planning.
      </div>
      <div style={{maxWidth:220}}><label className="fl">Date souhaitée</label><input type="date" value={f.sd} onChange={e=>set('sd',e.target.value)}/></div>
    </div>}

    {/* Demi-journée */}
    {(type==='demi'||type==='recup')&&<div style={{display:'flex',flexDirection:'column',gap:10}}>
      <div><label className="fl">Date</label><input type="date" value={f.sd} onChange={e=>set('sd',e.target.value)}/></div>
      <div>
        <label className="fl">Période</label>
        <div style={{display:'flex',gap:8}}>
          {[['am','🌅 Matin (jusqu\'à 13h)'],['pm','🌆 Après-midi (à partir de 13h)']].map(([v,l])=>(
            <button key={v} onClick={()=>set('demi',v)} style={{flex:1,padding:'10px',borderRadius:10,border:`2px solid ${f.demi===v?'var(--mn)':'var(--li)'}`,background:f.demi===v?'#e1f7ee':'var(--wh)',cursor:'pointer',fontSize:12,fontWeight:700,color:f.demi===v?'#1e6e3d':'var(--si)'}}>{l}</button>
          ))}
        </div>
      </div>
    </div>}

    {/* Indispo partielle */}
    {type==='indispo'&&<div style={{display:'flex',flexDirection:'column',gap:10}}>
      <div style={{background:'#fff4d6',border:'1px solid var(--ye)',borderRadius:9,padding:'9px 12px',fontSize:11,color:'var(--si)'}}>
        ℹ️ L'indisponibilité partielle ne génère pas de congés. Elle est visible dans le planning et doit être validée par l'admin.
      </div>
      <div><label className="fl">Date</label><input type="date" value={f.sd} onChange={e=>set('sd',e.target.value)}/></div>
      <div>
        <label className="fl">Type d'indisponibilité</label>
        <div style={{display:'flex',flexDirection:'column',gap:7}}>
          {[
            ['creneau','⏱ Créneau bloqué (ex: indispo de 14h à 17h)'],
            ['debut',  '▶ Disponible à partir de… (ex: libre à partir de 11h)'],
            ['fin',    '⏹ Disponible jusqu\'à… (ex: doit partir à 15h)'],
          ].map(([v,l])=>(
            <button key={v} onClick={()=>set('indispoType',v)} style={{padding:'9px 12px',borderRadius:9,border:`2px solid ${f.indispoType===v?'var(--or)':'var(--li)'}`,background:f.indispoType===v?'#fff4d6':'var(--wh)',cursor:'pointer',fontSize:12,fontWeight:f.indispoType===v?700:400,textAlign:'left',color:f.indispoType===v?'var(--or)':'var(--si)'}}>{l}</button>
          ))}
        </div>
      </div>
      {f.indispoType==='creneau'&&<div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10}}>
        <div><label className="fl">Indispo à partir de</label><input type="time" value={f.indispoStart} onChange={e=>set('indispoStart',e.target.value)}/></div>
        <div><label className="fl">Indispo jusqu'à</label><input type="time" value={f.indispoEnd} onChange={e=>set('indispoEnd',e.target.value)}/></div>
      </div>}
      {f.indispoType==='debut'&&<div style={{maxWidth:200}}>
        <label className="fl">Disponible à partir de</label><input type="time" value={f.indispoStart} onChange={e=>set('indispoStart',e.target.value)}/>
      </div>}
      {f.indispoType==='fin'&&<div style={{maxWidth:200}}>
        <label className="fl">Disponible jusqu'à</label><input type="time" value={f.indispoEnd} onChange={e=>set('indispoEnd',e.target.value)}/>
      </div>}
    </div>}

    {/* Arrêt maladie (admin uniquement) */}
    {type==='maladie'&&<div style={{display:'flex',flexDirection:'column',gap:10}}>
      <div style={{background:'#fff0e6',border:'1px solid #f5a623',borderRadius:9,padding:'9px 12px',fontSize:11,color:'#7a4400',lineHeight:1.5}}>
        🏥 L'arrêt maladie est saisi par l'admin à réception du certificat. Il est approuvé d'office et compte comme heures contractuelles non planifiables.
      </div>
      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10}}>
        <div><label className="fl">Début de l'arrêt</label><input type="date" value={f.sd} onChange={e=>set('sd',e.target.value)}/></div>
        <div><label className="fl">Fin de l'arrêt (inclus)</label><input type="date" value={f.ed} onChange={e=>set('ed',e.target.value)}/></div>
      </div>
      <div>
        <label className="fl">Sous-type</label>
        <div style={{display:'flex',gap:8}}>
          {[['maladie','🤒 Maladie ordinaire'],['at','⚠️ Accident du travail']].map(([v,l])=>(
            <button key={v} onClick={()=>set('malType',v)} style={{flex:1,padding:'10px',borderRadius:10,border:`2px solid ${f.malType===v?'#f5a623':'var(--li)'}`,background:f.malType===v?'#fff0e6':'var(--wh)',cursor:'pointer',fontSize:12,fontWeight:700,color:f.malType===v?'#7a4400':'var(--si)'}}>{l}</button>
          ))}
        </div>
      </div>
    </div>}

    <div><label className="fl">Motif (optionnel)</label><textarea rows="2" value={f.reason} onChange={e=>set('reason',e.target.value)} placeholder="Rendez-vous médical, contrainte personnelle…"/></div>

    <div style={{display:'flex',gap:8,justifyContent:'flex-end'}}>
      <button onClick={onC} className="btn bgh">Annuler</button>
      <button onClick={save} className="btn bmn">{adminMode?(isEdit?'💾 Enregistrer':'✓ Créer l\'absence'):'Envoyer la demande'}</button>
    </div>
  </div>);
}

function CommentaireModal({task,bien,sid,staff,existing,onSave,onClose}){
  const tt=TT[task?.type]||{};
  const me=staff?.find(s=>s.id===sid);
  const[texte,setTexte]=useState(existing?.texte||'');
  const[niveau,setNiveau]=useState(existing?.niveau||'info'); // info | attention | incident
  const niveaux=[
    {v:'info',     label:'Tout s\'est bien passé', emoji:'✅', c:'var(--ok)',   bg:'#e1f7ee'},
    {v:'attention',label:'Point à noter',          emoji:'⚠️', c:'var(--or)',   bg:'#fff4d6'},
    {v:'incident', label:'Incident / problème',    emoji:'🔴', c:'var(--dg)',   bg:'#fde0e0'},
  ];
  const handleSave=()=>{
    const com={
      id:existing?.id||'com'+Date.now(),
      tid:task?.id, bid:bien?.id, sid,
      type:task?.type, // checkin ou checkout
      date:today(), ts:now(),
      niveau, texte,
      lu:false
    };
    onSave(com);
    onClose();
  };
  return(<div style={{display:'flex',flexDirection:'column',gap:14}}>
    {/* Header tâche */}
    <div style={{background:`linear-gradient(135deg,${tt.bg||'var(--cr)'},var(--wh))`,borderRadius:10,padding:'11px 14px',borderLeft:`4px solid ${tt.c||'var(--or)'}`}}>
      <div className="D" style={{fontSize:15}}>{tt.e} {tt.l}{bien?.name?' · '+bien.name:''}</div>
      <div style={{fontSize:11,color:'var(--si)',marginTop:2}}>{fname(me)} · {fd(today())}</div>
    </div>
    {/* Niveau */}
    <div>
      <div style={{fontSize:11,textTransform:'uppercase',letterSpacing:'.06em',fontWeight:700,color:'var(--si)',marginBottom:8}}>Comment s'est passé l'intervention ?</div>
      <div style={{display:'flex',flexDirection:'column',gap:6}}>
        {niveaux.map(n=>(<label key={n.v} onClick={()=>setNiveau(n.v)} style={{display:'flex',alignItems:'center',gap:10,padding:'10px 14px',borderRadius:10,border:`2px solid ${niveau===n.v?n.c:'var(--li)'}`,background:niveau===n.v?n.bg:'var(--wh)',cursor:'pointer',userSelect:'none',transition:'all .15s'}}>
          <span style={{fontSize:20}}>{n.emoji}</span>
          <span style={{fontWeight:700,fontSize:13,color:niveau===n.v?n.c:'var(--ink)'}}>{n.label}</span>
          <span style={{marginLeft:'auto',fontSize:18,color:niveau===n.v?n.c:'var(--li)'}}>{niveau===n.v?'◉':'○'}</span>
        </label>))}
      </div>
    </div>
    {/* Commentaire libre */}
    <div>
      <label className="fl">Commentaire {niveau==='info'?'(optionnel)':'*'}</label>
      <textarea rows="4" value={texte} onChange={e=>setTexte(e.target.value)} placeholder={
        niveau==='info'     ?'Rien de particulier à signaler…':
        niveau==='attention'?'Décrivez le point à noter (retard, remarque client, équipement à vérifier…)':
                             'Décrivez l\'incident clairement (comportement client, dégât, problème de sécurité…)'
      } style={{fontSize:13,lineHeight:1.6}}/>
    </div>
    {/* Note admin-only */}
    <div style={{fontSize:11,color:'var(--si)',background:'var(--bg)',borderRadius:8,padding:'8px 11px',display:'flex',gap:6,alignItems:'flex-start'}}>
      <span>🔒</span>
      <span>Ce commentaire est <strong>visible uniquement par l'admin</strong>. Il n'apparaît pas sur l'interface propriétaire.</span>
    </div>
    {/* Boutons */}
    <div style={{display:'flex',gap:8,justifyContent:'flex-end'}}>
      <button onClick={onClose} className="btn bgh">Annuler</button>
      <button onClick={handleSave} className="btn bor" disabled={niveau!=='info'&&!texte.trim()}>Enregistrer</button>
    </div>
  </div>);
}

// ─── Seuil qualité (durée min/max, v154) : signalement d'empêchement ───
// Affiché uniquement quand le bouton ⏹ Fin est verrouillé (durée hors de la fourchette
// configurée sur le bien). Décision Claire : le salarié ne voit JAMAIS le seuil ni le
// temps restant — ce texte reste volontairement générique, aucun chiffre nulle part.
// L'envoi ne débloque RIEN par lui-même : c'est une escalade vers la Direction, jamais
// une auto-validation — seule la Direction débloque, à la main, via l'éditeur de
// pointage admin déjà existant (PointageAlsEditor).
// Reprise silencieuse (v161, 15/08/2026, demande Claire) : côté salarié, pour un ménage
// trop RAPIDE uniquement (sens==='sous'), le bouton "Annuler" devient "↩️ Reprendre le
// ménage" — même geste techniquement (rien n'est écrit dans als7, la tâche reste ouverte,
// c'était déjà vrai avant), mais désormais assumé comme un vrai chemin ET tracé en
// arrière-plan (onReprise, nouveau callback) : aucun motif à saisir, aucun écran de
// confirmation, aucune notification poussée vers la Direction — silencieux pour le
// salarié. Objectif de Claire : repérer un salarié qui teste sciemment les seuils
// (Fin → bloqué → ferme → retente) sans l'alerter en temps réel à chaque tentative.
// Pour sens==='dessus' (trop long) et pour les comptes Direction (isStaff=false), le
// bouton reste "Annuler" classique, sans trace — hors périmètre de cette demande.
function DureeSignalModal({bien,sens,isStaff,onSend,onClose,onReprise}){
  const[motif,setMotif]=useState('');
  const[engage,setEngage]=useState(false);
  // Seconde case, spécifique aux ménages trop rapides (v159, 14/08/2026, demande Claire) :
  // engagement distinct de celui sur l'exactitude du motif — porte sur la qualité du
  // ménage lui-même, pas sur la véracité de l'explication. Non pertinente si le ménage est
  // trop LONG (l'inverse), donc non exigée dans ce cas.
  const[engageQualite,setEngageQualite]=useState(false);
  const[sent,setSent]=useState(false);
  // Validation renforcée (v159, 14/08/2026, demande Claire) : un simple "." passait la
  // validation d'origine (motif.trim() non vide suffisait) alors que depuis v156 l'envoi
  // débloque directement la tâche — c'était le SEUL garde-fou réel contre un motif bidon.
  // Uniquement côté salarié (isStaff) : les comptes Direction gardent la validation d'origine.
  const motifTrim=motif.trim();
  const contenuReel=/[a-zA-ZÀ-ÿ]{3,}/.test(motifTrim); // au moins 3 lettres à la suite (rejette "..........", "1234567890"…)
  const motifValide=isStaff?(motifTrim.length>=10&&contenuReel):!!motifTrim;
  const peutEnvoyer=motifValide&&engage&&(sens!=='sous'||engageQualite);
  const handleSend=()=>{
    if(!peutEnvoyer)return;
    onSend(motifTrim,sens==='sous'?engageQualite:undefined);
    setSent(true);
  };
  // Reprise silencieuse : uniquement salarié + ménage trop rapide (voir doc au-dessus du
  // composant). Ferme la modale comme "Annuler" l'a toujours fait (aucune écriture als7,
  // rien à annuler côté données) et déclenche en plus la trace best-effort côté appelant.
  const reprisePossible=isStaff&&sens==='sous';
  const handleReprise=()=>{
    onReprise&&onReprise();
    onClose();
  };
  // Révisé 11/08/2026 (décision Claire) : l'envoi débloque directement la clôture du
  // ménage (ctx.retry() côté StaffUI/GerantUI) — ce n'est plus une simple attente d'un
  // retour de la Direction, d'où le nouvel écran de confirmation et la case d'engagement
  // ci-dessous, seule garde-fou restant contre un usage abusif.
  if(sent)return(<div style={{display:'flex',flexDirection:'column',gap:14,textAlign:'center',padding:'6px 0'}}>
    <div style={{fontSize:40}}>✅</div>
    <div className="D" style={{fontSize:16,color:'var(--ok)'}}>Ménage clôturé, la Direction est prévenue</div>
    <div style={{fontSize:12,color:'var(--si)'}}>Elle peut revenir vers vous si besoin.</div>
    <button onClick={onClose} className="btn bgh" style={{marginTop:6}}>Fermer</button>
  </div>);
  return(<div style={{display:'flex',flexDirection:'column',gap:14}}>
    <div style={{fontSize:12,color:'var(--si)'}}>Ce ménage{bien?.name?` (${bien.name})`:''} sort de la fourchette de durée habituelle. Expliquez la situation — la Direction sera prévenue immédiatement et le ménage sera clôturé.</div>
    {/* Rappel qualité (v159, 14/08/2026, demande Claire) — uniquement pour un ménage trop
        rapide : un ménage fait en moins de temps doit être irréprochable au contrôle, ce
        n'est jamais un motif pour bâcler. Vouvoiement, formulation non genrée. */}
    {sens==='sous'&&<div style={{background:'#fff4d6',border:'1.5px solid var(--or)',borderRadius:9,padding:'10px 13px',fontSize:12,color:'#7a5a00',lineHeight:1.5}}>
      ⚡ Ce ménage a été terminé nettement plus vite que la durée habituelle. Un ménage rapide doit être un sans-faute au contrôle.
    </div>}
    <div>
      <label className="fl">Motif *</label>
      <textarea rows="4" value={motif} onChange={e=>setMotif(e.target.value)} placeholder="Expliquez ce qui se passe (appartement déjà nickel, propriétaire annule, urgence…)" style={{fontSize:13,lineHeight:1.6}}/>
      {isStaff&&motifTrim.length>0&&!motifValide&&<div style={{fontSize:11,color:'var(--dg)',marginTop:4}}>Merci de préciser un peu plus (10 caractères minimum, une vraie explication).</div>}
    </div>
    <label style={{display:'flex',gap:8,alignItems:'flex-start',fontSize:12,cursor:'pointer'}}>
      <input type="checkbox" checked={engage} onChange={e=>setEngage(e.target.checked)} style={{width:16,height:16,marginTop:2,flexShrink:0}}/>
      <span>Je certifie que ce motif est exact et j'en assume la responsabilité.</span>
    </label>
    {sens==='sous'&&<label style={{display:'flex',gap:8,alignItems:'flex-start',fontSize:12,cursor:'pointer',background:'#fff4d6',border:'1px solid var(--or)',borderRadius:9,padding:'9px 12px'}}>
      <input type="checkbox" checked={engageQualite} onChange={e=>setEngageQualite(e.target.checked)} style={{width:16,height:16,marginTop:2,flexShrink:0}}/>
      <span>Je confirme que l'appartement est parfaitement propre et prêt, malgré ce temps plus court.</span>
    </label>}
    <div style={{display:'flex',gap:8,justifyContent:'flex-end'}}>
      {reprisePossible
        ?<button onClick={handleReprise} className="btn bgh">↩️ Reprendre le ménage</button>
        :<button onClick={onClose} className="btn bgh">Annuler</button>}
      <button onClick={handleSend} className="btn bor" disabled={!peutEnvoyer}>📨 Envoyer à la direction</button>
    </div>
  </div>);
}

export { LeaveForm, CommentaireModal, DureeSignalModal };
